import { getStore } from 'owa-mail-compose-store/lib/store/composeStore';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
export default {
    MailComposeNew: {
        datapoint: {
            name: 'MailComposeNew',
            options: { isQos: true },
            customData: function (actionSource) { return [
                actionSource,
                !isTabViewEnabled() && !!getStore().defaultViewState,
            ]; },
        },
    },
    MailComposeFromHeader: { datapoint: { name: 'MailComposeFromHeader' } },
};
//# sourceMappingURL=datapoints.js.map